import React from "react";
import { motion } from "framer-motion";
import { recognition } from "../data/mock";
import { Reveal, ChapterTag, EASE } from "../lib/motion";

export const PainPoints = () => {
  return (
    <section id="recognition" data-testid="recognition-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="01" label="Recognition" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.1]">
            {recognition.heading}
          </h2>
          <p className="mt-5 text-stone-600 leading-relaxed max-w-2xl text-base md:text-lg">
            {recognition.intro}
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-stone-200 rounded-2xl overflow-hidden border border-stone-200">
          {recognition.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: EASE }}
              className="group bg-white p-7 hover:bg-[#FAF7F2] transition-colors duration-300"
              data-testid={`recognition-card-${i}`}
            >
              <span className="text-[11px] font-semibold text-brand-600 tracking-[0.2em]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 text-base md:text-lg font-display font-semibold text-stone-900 leading-snug group-hover:text-brand-800 transition-colors duration-300">
                {item.title}
              </h3>
              <p className="mt-2.5 text-sm text-stone-500 leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
          {/* Closing card */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: 0.16, ease: EASE }}
            className="bg-[#032e2d] p-7 flex flex-col justify-center sm:col-span-2 lg:col-span-2"
            data-testid="recognition-closing"
          >
            <p className="font-display  text-lg md:text-xl text-teal-50 leading-relaxed">
              "{recognition.closing}"
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
